import { IndicadorColeta } from "model/indicadores/IndicadorColeta";
import { useEffect, useState } from "react";
import { VictoryLabel, VictoryPie, VictoryTheme } from "victory";
import { formatarDataColeta } from "../IndicadorUtil";
import IndicadorDashboardItem from "model/indicadores/IndicadorDashboardItem";
import IndicadorService from "service/indicadores/IndicadorService";

type Props = {
    dados: IndicadorDashboardItem[];
    unidadeMedida?: string | null;
}

const indicadorService = new IndicadorService();
export default function IndicadorChartPie(props: Props) {

    const [total, setTotal] = useState<number>(0);
    useEffect(() => {
        const total = props.dados.reduce((acc, dado) => acc + (dado?.coleta?.valorColeta || 0), 0);
        setTotal(total);
    }, [])

    const colors = [
        "#2F4F4F",  // Verde escuro
        "#B22222",  // Vermelho tijolo
        "#8B4513",  // Marrom
        "#4B0082",  // Índigo
        "#800000",  // Vinho
        "#556B2F",  // Verde oliva escuro
        "#483D8B",  // Azul escuro
        "#808000",  // Oliva
        "#6A5ACD",  // Azul ardósia
        "#800080",  // Roxo
        "#2E8B57",  // Verde mar
        "#D2691E",  // Chocolate
        "#9932CC",  // Orquídea escura
        "#228B22",   // Verde floresta
        "#A52A2A",  // Marrom vermelho
    ];

    return <div style={{ display: "flex", columnGap: 24, alignItems: "center" }}>
        <div style={{ width: "50%" }}>
            <svg viewBox="0 0 400 400">
                <VictoryPie
                    colorScale={colors}
                    width={400}
                    height={400}
                    standalone={false}
                    theme={VictoryTheme.material}
                    data={props.dados.map((dado: IndicadorDashboardItem) => ({
                        ...dado,
                        x: formatarDataColeta(dado.coleta),
                        y: dado?.coleta?.valorColeta||0
                    }))}
                    innerRadius={50}
                    labelRadius={100}
                    labels={({ datum }) => datum.y * 100 / (total || 1) > 10 ? `${datum.x}\n${indicadorService.getValorConvertido(props.unidadeMedida||"", datum.y)}` : ""}
                    labelComponent={
                        <VictoryLabel
                            style={[
                                { fill: '#FFF', fontFamily: "arial", fontSize: 10, fontWeight: 'bold', textAnchor: 'middle' }
                            ]}
                        />
                    }
                />
                <VictoryLabel
                    textAnchor="middle"
                    style={{ fontSize: 20 }}
                    x={200}
                    y={200}
                    text={total}
                />
            </svg>
        </div>
        <div style={{ width: '50%', boxSizing: "border-box", flex: 1, display: "flex", flexDirection: "column", rowGap: 10, height: "100%", overflowY: "scroll" }}>
            {props.dados.map((item, index) => (
                <div style={{ display: "flex", alignItems: "center", columnGap: 10, width: "100%" }}>
                    <div style={{ minWidth: 20, minHeight: 20, backgroundColor: colors[index], borderRadius: 10 }}></div>
                    <span style={{ textOverflow: "ellipsis", overflow: "hidden", fontWeight: 700 }}>{formatarDataColeta(item.coleta)}:</span>
                    <span style={{ textOverflow: "ellipsis", overflow: "hidden" }}>{indicadorService.getValorConvertido(props.unidadeMedida||"", item?.coleta?.valorColeta||0)}</span>
                </div>
            ))}
        </div>
    </div>
}